import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, filter, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { CustomTableSelectComponent } from 'src/app/components/custom-table-select/custom-table-select.component';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { StockMaxMinModel } from 'src/app/models/inventory/stock-max-min.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { ArticleService } from 'src/app/services/archive/article.service';
import { StoreService } from 'src/app/services/archive/store.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { InventoryService } from 'src/app/services/inventory/inventory.service';
import { StockMaxMinService } from 'src/app/services/inventory/stock-max-min.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { SubrentalEntryDetailService } from 'src/app/services/subrental/subrental-entry-detail.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { Location } from '@angular/common';
import Swal from 'sweetalert2';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { UserModel } from 'src/app/models/authentication/user.model';
import { WindowService } from 'src/app/services/authentication/window.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { OptionWindowModel } from 'src/app/models/authentication/option-window.model';
import { OptionWindowService } from 'src/app/services/authentication/option-window.service';
import { WindowEnums } from 'src/app/enum/window-enums';

@Component({
  selector: 'app-register-stock-max-min',
  templateUrl: './register-stock-max-min.component.html',
  styleUrls: ['./register-stock-max-min.component.scss'],
  standalone: false
})
export class RegisterStockMaxMinComponent implements OnInit {


  @ViewChild('articleSelection') articleSelectionModalComponent?: CustomModalComponent | null = null;

  articleId: number = 0;
  ascendantArticle: boolean = true;
  branchId: number = 0;
  columnSortArticle: string | null = null;
  dataArticle: PagedResponseModel<any> = new PagedResponseModel<any>();
  disabledForm: boolean = false;
  filtersArticle: ColumnResponseModel[] = [];
  formStockMaxMin: FormGroup = new FormGroup({});
  headerArticle: ColumnResponseModel[] = [];
  inventoryId: number = 0;
  inputsForArticlesSelection$ = new BehaviorSubject<any>({
    headers: [],
    data: [],
    showCheckbox: true,
    showRecover: true,
    isMultipleSelect: false,
    filters: [],
  });
  isOpened: string | undefined = undefined;
  limitArticle: number = 10;
  listArticles: any[] = [];
  listBranches: any[] = [];
  listInventories: any[] = [];
  listObservers: Array<Subscription> = new Array<Subscription>();
  listStores: any[] = [];
  nameWindow: string = 'Captura Topes Máximos-Mínimos';
  output$ = new Subject<any>();
  pageArticle: number = 1;
  permissionUpdatable: boolean = false;
  permissionsUser: OptionWindowModel[] = [];
  projectName = ProjectName.projectName;
  storeId: number = 0;
  stockMaxMinContract: StockMaxMinModel = new StockMaxMinModel();
  stockMaxMinId: number = 0;
  storeLocation: string = '';
  subscription!: Subscription;
  url: string = 'stock-max-min';
  userAuthenticated: UserModel = new UserModel();
  componentTableSelection = CustomTableSelectComponent;

  constructor(
    private articleService: ArticleService,
    private activatedRoute: ActivatedRoute,
    private branchService: BranchService,
    private formBuilder: FormBuilder,
    private headerService: HeaderService,
    private inventoryService: InventoryService,
    private inventoryEntryService: InventoryService,
    private location: Location,
    private router: Router,
    private stockMaxMinService: StockMaxMinService,
    private storeService: StoreService,
    private subrentalEntryDetailService: SubrentalEntryDetailService,
    private optionWindowService: OptionWindowService,
    private toastHandlerService: ToastHandlerService,
    private title: Title,
    private userAuthenticatedService: UserAuthenticatedService,
    private windowService: WindowService,
  ) {
  }

  async ngOnInit() {
    this.validateForm(new StockMaxMinModel());
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    await this.getPermission();
    //Leo el id la URL
    this.activatedRoute.params.subscribe(params => {
      this.stockMaxMinId = params?.id ? Number(params.id) : 0;
    });

    this.handleInitialState();
    this.subscription = this.output$.subscribe(({ type, payload }) => {
      switch (type) {
        case 'onPageChange':
          this.onPageChangeArticle(payload);
          break;

        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }

    this.listObservers.forEach(sub => sub.unsubscribe());
  }

  changeSelection() {
    this.stockMaxMinId = 0;
    const model = new StockMaxMinModel();
    model.inventoryId = this.inventoryId;
    model.branchId = this.branchId;
    model.storeId = this.storeId;
    model.articleId = 0;
    model.stockMin = 0;
    model.stockMax = 0;

    this.stockMaxMinContract = model;
    this.validateForm(model);
  }

  async createNewStockMaxMin() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('warning', `El usuario no tiene permisos para crear Topes Máximos-Mínimos.
        Comuníquese con el administrador del sistema.`);
      return;
    }
    await Promise.all([
      this.getFirstBranchByUserAuthenticated(),
      this.getFirstInventoryByCompanyAuthenticated()
    ]);

    this.stockMaxMinId = 0;
    this.stockMaxMinContract = new StockMaxMinModel();
    this.stockMaxMinContract.inventoryId = this.inventoryId;
    this.stockMaxMinContract.branchId = this.branchId;
    this.validateForm(this.stockMaxMinContract);
    // Limpio el campo de articulo
    this.resetArticleSelection();
    this.location.replaceState(`/stock-max-min/register`);
  }

  async deleteStockMaxMin() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('error', `El usuario no tiene permisos para eliminar Topes Máximos-Mínimos.
        Comuníquese con el administrador del sistema.`);
      return;
    }
    if (!this.stockMaxMinId || this.stockMaxMinId === 0) {
      this.toastHandlerService.showToast('warning', 'No existe un Tope Máximos-Mínimos para eliminar.'
      );
      return;
    }

    const result = await Swal.fire({
      title: 'Atención',
      text: '¿Realmente desea eliminar este Tope Máximos-Mínimos?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí',
      cancelButtonText: 'No'
    });

    if (!result.isConfirmed) return;

    try {
      await firstValueFrom(this.stockMaxMinService.deleteStockMaxMin(this.stockMaxMinId));
      this.createNewStockMaxMin();
      this.toastHandlerService.showToast('success', 'Tope Máximos-Mínimos eliminado exitosamente.'
      );
    } catch (error) {
      console.error('Error al eliminar el Tope Máximos-Mínimos', error);
      this.toastHandlerService.showToast('error', 'Ocurrió un error al eliminar el Tope Máximos-Mínimos.'
      );
    }
  }

  async getAllLists() {
    try {
      const [inventories, branches, articles] = await Promise.all([
        firstValueFrom(this.inventoryEntryService.getAllInventoriesForSelectAsync()),
        firstValueFrom(this.branchService.getAllBranchesForSelectAsync()),
        firstValueFrom(this.stockMaxMinService.getArticlesForSelectByInventoryIdAsync(this.inventoryId)),
      ]);
      this.listInventories = inventories;
      this.listBranches = branches;
      this.listArticles = articles;

      return true;
    } catch (error) {
      console.error('Error cargando listas', error);
      return false
    }
  }

  async getArticle(articleId: number | null, edit: boolean) {
    let validArticle = null;
    if (articleId != null) {
      const article = await firstValueFrom(this.articleService.getArticleById(articleId));
      if (article) {
        validArticle = articleId;
      }
    }

    this.articleId = validArticle ?? 0;
    this.formStockMaxMin.controls["articleId"].patchValue(validArticle);
    if (edit) {
      this.getStockMaxMinByKeysAsync();
    }
  }

  async getArticlesForEntries() {
    try {
      const response = await firstValueFrom(this.stockMaxMinService.getArticlesForSelect(this.inventoryId,
        this.pageArticle, this.limitArticle, this.columnSortArticle, this.ascendantArticle, this.filtersArticle));
      this.dataArticle = response;
      this.updateInputs();
    } catch (error) {
      console.error('Error al obtener la lista de los artículos', error);
    }
  }

  async getBranch(branchId: number | null, reload: boolean) {
    let validBranch = null;
    if (branchId != null) {
      validBranch = branchId;
    }

    this.branchId = validBranch ?? 0;
    this.formStockMaxMin.controls["branchId"].patchValue(validBranch);

    if (reload) {
      await this.onInventoryOrBranchChange();
    }
  }

  async getButtonClick(buttonClick: any) {
    try {
      let response: StockMaxMinModel | null = null;

      switch (buttonClick.target.id) {
        case 'first':
          response = await firstValueFrom(
            this.stockMaxMinService.getFirstStockMaxMin()
          );
          break;

        case 'previus':
          response = await firstValueFrom(
            this.stockMaxMinService.getPreviousStockMaxMinByKeysAsync(this.stockMaxMinId)
          );
          break;

        case 'next':
          response = await firstValueFrom(
            this.stockMaxMinService.getNextStockMaxMinByKeysAsync(this.stockMaxMinId)
          );
          break;

        case 'last':
          response = await firstValueFrom(
            this.stockMaxMinService.getLastStockMaxMin()
          );
          break;
      }

      if (!response) return;

      this.stockMaxMinContract = response;
      this.stockMaxMinId = response.stockMaxMinId;
      this.inventoryId = response.inventoryId;
      this.branchId = response.branchId;
      this.storeId = response.storeId;

      await this.loadStoresByBranchInventory();

      this.validateForm(response);

      await this.getArticlesForEntries();

      if (response.articleId && response.articleId > 0) {
        await this.getArticle(response.articleId, false);
      }
      this.location.replaceState(`/stock-max-min/register/${response.stockMaxMinId}`);
    } catch (error) {
      console.error('warning', 'No existen más registros para navegar.', error);
    }
  }

  async getColumnsArticle() {
    this.headerArticle = await firstValueFrom(
      this.subrentalEntryDetailService.getColumnsForArticles()
    );
  }

  async getFirstBranchByUserAuthenticated() {
    try {
      const response = await firstValueFrom(this.branchService.getFirstBranchByUserAuthenticatedAsync());
      this.branchId = response.branchId;
    } catch (error) {
      console.error('Error al obtener la sucursal.', error);
    }
  }

  async getFirstInventoryByCompanyAuthenticated() {
    try {
      const response = await firstValueFrom(this.inventoryService.getFirstInventoryByCompanyAuthenticatedAsync());
      this.inventoryId = response.inventoryId;
      await this.getAllLists();
    } catch (error) {
      console.error('Error al obtener inventario principal de la compañia.', error);
    }
  }

  async getInventory(inventoryId: number | null, reload: boolean) {
    let validInventory = null;

    if (inventoryId != null) {
      const inventory = await firstValueFrom(this.inventoryService.getInventoryById(inventoryId));
      if (inventory) {
        validInventory = inventoryId;
      }
    }

    this.inventoryId = validInventory ?? 0;
    this.formStockMaxMin.controls["inventoryId"].patchValue(validInventory);

    if (reload) {
      this.onInventoryOrBranchChange();
    }
  }

  async getPermission() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);

    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(
        AuthenticationContants.keyWindowsOpenedLocalStorage,
        JSON.stringify(windowsOpened)
      );

      if (this.isOpened) {
        this.toastHandlerService.showToast('error', `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`, 'Atención');
      }
    } else {
      localStorage.clear();
    }

    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
      this.getPermissionsForUserByWindow();
    } catch (error) {
      console.error('Error al buscar los permisos por perfil.', error);
    }
  }

  async getPermissionsForUserByWindow() {
    this.userAuthenticated = await firstValueFrom(
      this.userAuthenticatedService.userObservable.pipe(
        filter(user => user && user.userId !== 0)
      )
    );
    this.permissionsUser = await firstValueFrom(this.optionWindowService.getPermissionsForUserByWindow(WindowEnums.StockMaxMin));
  }

  async getStockMaxMinById() {
    try {
      this.stockMaxMinContract = await firstValueFrom(this.stockMaxMinService.getStockMaxMinById(this.stockMaxMinId));
      this.branchId = this.stockMaxMinContract.branchId;
      this.inventoryId = this.stockMaxMinContract.inventoryId;
      this.storeId = this.stockMaxMinContract.storeId;
      await this.loadStoresByBranchInventory();
      this.validateForm(this.stockMaxMinContract);
      if (this.stockMaxMinContract.articleId && this.stockMaxMinContract.articleId > 0) {
        await this.getArticle(this.stockMaxMinContract.articleId, false);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async getStockMaxMinByKeysAsync() {
    const stockMaxMin = await firstValueFrom(this.stockMaxMinService.getStockMaxMinByKeysAsync(this.inventoryId, this.branchId, this.storeId, this.articleId))
    if (stockMaxMin == null) return;
    this.stockMaxMinContract = stockMaxMin;
    this.stockMaxMinId = this.stockMaxMinContract.stockMaxMinId;
    this.validateForm(this.stockMaxMinContract);
    this.location.replaceState(`/stock-max-min/register/${this.stockMaxMinContract.stockMaxMinId}`);
  }

  async getStore(storeId: number | null, reload: boolean) {
    let validStore = null;
    if (storeId != null) {
      const store = await firstValueFrom(this.storeService.getStoreById(storeId));
      if (store) {
        validStore = storeId;
      }
    }
    this.storeId = validStore ?? 0;
    this.formStockMaxMin.controls["storeId"].patchValue(validStore);

    if (reload) {
      await this.onStoreChange();
    }
  }

  goToBack(event: Event) {
    event.preventDefault();
    this.router.navigate(['/stock-max-min']);
  }

  async handleInitialState() {
    if (this.stockMaxMinId !== 0) {
      this.getStockMaxMinById();
    } else {
      await Promise.all([
        this.getFirstBranchByUserAuthenticated(),
        this.getFirstInventoryByCompanyAuthenticated()
      ]);
      await this.loadStoresByBranchInventory();
      this.createNewStockMaxMin();
    }
  }

  async handleSelectedItem(selectedItem: any) {
    const articleId = parseInt(selectedItem[0]?.id);
    this.getArticle(articleId, true)
  }

  async loadStoresByBranchInventory() {
    if (!this.branchId) {
      this.listStores = [];
      return;
    }

    try {
      this.listStores = await firstValueFrom(
        this.storeService.getStoresActivesByBranchInventoryForSelect(this.branchId, this.inventoryId
        )
      );
    } catch (error) {
      console.error('Error al cargar bodegas por Sucursal', error);
      this.listStores = [];
    }
  }

  async onInventoryOrBranchChange() {
    this.location.replaceState(`/${this.url}/register/0`);
    this.storeId = 0;
    this.formStockMaxMin.get('storeId')?.patchValue(null);
    this.formStockMaxMin.get('articleId')?.patchValue(null);
    this.formStockMaxMin.get('stockMin')?.patchValue(null);
    this.formStockMaxMin.get('stockMax')?.patchValue(null);
    this.formStockMaxMin.get('storeLocation')?.patchValue(null);
    this.articleId = 0;

    await this.loadStoresByBranchInventory();
  }

  async onStoreChange() {
    this.location.replaceState(`/${this.url}/register/0`);
    this.formStockMaxMin.get('articleId')?.patchValue(null);
    this.formStockMaxMin.get('stockMin')?.patchValue(null);
    this.formStockMaxMin.get('stockMax')?.patchValue(null);
    this.formStockMaxMin.get('storeLocation')?.patchValue(null);
    this.articleId = 0;
  }

  async onPageChangeArticle(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.pageArticle = event.page;
    this.limitArticle = event.pageSize;
    this.columnSortArticle = event.sortField || null;
    this.ascendantArticle = event.sortOrder === 1;
    this.getArticlesForEntries();
  }

  async openArticleSelectionModal() {
    this.filtersArticle = [];
    this.updateInputs();
    await Promise.all([
      this.getColumnsArticle(),
      this.getArticlesForEntries()
    ]);
    this.articleSelectionModalComponent && this.articleSelectionModalComponent.show();
  }

  resetArticleSelection() {
    this.articleId = 0;
    this.filtersArticle = [];
    this.pageArticle = 1;

    this.inputsForArticlesSelection$.next({
      headers: this.headerArticle,
      data: new PagedResponseModel<any>(),
      showCheckbox: true,
      showRecover: true,
      isMultipleSelect: false,
      filters: [],
    });
  }

  async send() {
    Object.keys(this.formStockMaxMin.controls).forEach((key) => {
      const control = this.formStockMaxMin.get(key);
      if (control && control.invalid) {
        console.warn(`${key} es inválido`, control.errors, control.value);
      }
    });
    if (this.formStockMaxMin.valid) {
      const modelStockMaxMin = this.formStockMaxMin.getRawValue() as StockMaxMinModel;
      //Valido cantidades antes de asignar datos al modelo
      if (!this.validateStockMinMax(this.formStockMaxMin.get('stockMin')?.value, this.formStockMaxMin.get('stockMax')?.value)) {
        this.toastHandlerService.showToast('warning', 'Revise las cantidades ingresadas.', 'Atención');
        return;
      }

      if (modelStockMaxMin.stockMax <= 0 || modelStockMaxMin.stockMin <= 0) {
        this.toastHandlerService.showToast('warning', 'Las cantidades de stock mínimo y máximo deben ser mayores a cero.', 'Atención');
        return;
      }

      try {
        if (this.stockMaxMinId == 0) {
          const response = await firstValueFrom(this.stockMaxMinService.createStockMaxMin(modelStockMaxMin));
          this.stockMaxMinId = response.stockMaxMinId;
          this.stockMaxMinContract = response;
          this.validateForm(response);
          this.location.replaceState(`/${this.url}/register/${this.stockMaxMinId}`);
          this.toastHandlerService.showToast('success', 'Tope Máximo-Mínimo creado exitosamente');

        } else {
          this.stockMaxMinContract.inventoryId = modelStockMaxMin.inventoryId;
          this.stockMaxMinContract.branchId = modelStockMaxMin.branchId;
          this.stockMaxMinContract.storeId = modelStockMaxMin.storeId;
          this.stockMaxMinContract.articleId = modelStockMaxMin.articleId;
          this.stockMaxMinContract.stockMin = modelStockMaxMin.stockMin;
          this.stockMaxMinContract.stockMax = modelStockMaxMin.stockMax;
          this.stockMaxMinContract.storeLocation = modelStockMaxMin.storeLocation;
          try {
            const response = await firstValueFrom(this.stockMaxMinService.updateStockMaxMin(this.stockMaxMinContract));
            this.stockMaxMinContract = response;
            this.validateForm(this.stockMaxMinContract);
            this.toastHandlerService.showToast('success', 'Tope Máximo-Mínimo actualizado exitosamente');
          } catch (error) {
            console.error('Error al actualizar el Tope Máximo-Mínimo', error);
            this.toastHandlerService.showToast('error', 'Ocurrió un error al actualizar el Tope Máximo-Mínimo');
          }
        }
      } catch (error) {
        console.error(error);
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages(): void {
    const controlMessages: Record<string, Record<string, string>> = {
      inventoryId: {
        required: 'El campo Inventario es requerido.',
        min: 'Debe seleccionar un Inventario válido.'
      },
      branchId: {
        required: 'El campo Sucursal es requerido.',
        min: 'Debe seleccionar una Sucursal válida.'
      },
      storeId: {
        required: 'El campo Bodega es requerido.',
        min: 'Debe seleccionar una Bodega válida.'
      },
      articleId: {
        required: 'El campo Artículo es requerido.',
        min: 'Debe seleccionar un Artículo válido.'
      },
      stockMin: {
        required: 'El campo Tope Mínimo es requerido.',
        min: 'El Tope Mínimo no puede ser negativo.',
        max: 'El Tope Mínimo supera el valor permitido'
      },
      stockMax: {
        required: 'El campo Tope Máximo es requerido.',
        min: 'El Tope Máximo no puede ser negativo.',
        max: 'El Tope Mínimo supera el valor permitido'
      }
    };

    Object.keys(this.formStockMaxMin.controls).forEach(controlName => {
      const control = this.formStockMaxMin.get(controlName);
      if (control && control.invalid && control.errors) {
        const messages = controlMessages[controlName];
        Object.keys(control.errors).forEach(errorKey => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  updateInputs() {
    this.inputsForArticlesSelection$.next({
      headers: this.headerArticle,
      data: this.dataArticle,
      showCheckbox: true,
      showRecover: true,
      isMultipleSelect: false,
      filters: this.filtersArticle,
    });
  }

  validateForm(stockMaxMin: StockMaxMinModel) {
    this.formStockMaxMin = this.formBuilder.group({
      inventoryId: [stockMaxMin.inventoryId, [Validators.required, Validators.min(1)]],
      branchId: [stockMaxMin.branchId, [Validators.required, Validators.min(1)]],
      storeId: [stockMaxMin.storeId, [Validators.required, Validators.min(1)]],
      articleId: [stockMaxMin.articleId, [Validators.required, Validators.min(1)]],
      stockMin: [stockMaxMin.stockMin, [Validators.required, Validators.min(0), Validators.max(99999999.99)],],
      stockMax: [stockMaxMin.stockMax, [Validators.required, Validators.min(0), Validators.max(99999999.99)],],
      storeLocation: [stockMaxMin.storeLocation ?? '', [Validators.maxLength(100)]],
      userNameUpdate: [{ value: stockMaxMin.userNameUpdate ?? '', disabled: true }],
      updateDate: [{ value: stockMaxMin.updateDate ?? '', disabled: true }]
    });
  }

  validateStockMinMax(min: number, max: number): boolean {
    if (max < min) {
      this.toastHandlerService.showToast('warning', 'El tope máximo no puede ser menor que el mínimo');
      return false;
    }
    return true;
  }
}